<div class="export-panel">
  <!-- Title bar -->
  <div class="export-title">
    <span>{{ mode === 'pdf' ? 'PDF report' : 'CSV file' }}</span>
  </div>

  <!-- Main content -->
  <div class="export-content">
    <!-- PDF mode: template selector + section toggles -->
    <ng-container *ngIf="mode === 'pdf'">
      <div class="template-row">
        <span class="template-label">{{ 'ExportPDFTemplate' | t }}</span>
        <select class="template-select" disabled>
          <option>{{ 'ExportProjectVericurePdfTemplate' | t }}</option>
        </select>
      </div>

      <div class="section-list">
        <div class="section-item" *ngFor="let section of sections">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="flags[section.key]"
            />
            <span class="checkmark" [class.checked]="flags[section.key]"></span>
            <span class="section-name">{{ section.label }}</span>
          </label>
        </div>
      </div>
    </ng-container>

    <!-- CSV mode: empty content area -->
    <ng-container *ngIf="mode === 'csv'">
      <div class="csv-info">
        <p>{{ 'ExportProjectExportAllTemperatureMeasurementsAsA' | t }}</p>
        <p class="csv-detail">{{ 'ExportProjectIncludesProjectMetadataMeasurementConfigurationAnd' | t }}</p>
      </div>
    </ng-container>

    <!-- Error message -->
    <div class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</div>
    <!-- The server's own reason, verbatim. Without it a denial is
         indistinguishable from a transient glitch. -->
    <div class="error-detail" *ngIf="errorDetail">{{ errorDetail }}</div>
  </div>

  <!-- Bottom action bar -->
  <div class="export-actions">
    <!-- The Back button stood here. It existed because the left-nav tabs did not
         work while this pane was open, and it was the only way out. They work
         now — any tab click exits to that tab — so a bespoke exit control would
         be a second, weaker way to do the same thing, in a place no other screen
         has one. The export TAB itself still toggles the pane shut. -->

    <button
      class="btn-confirm"
      (click)="generate()"
      [disabled]="isGenerating"
      [title]="'ExportProjectGenerateReport' | t"
    >
      <span *ngIf="!isGenerating">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4 10L8 14L16 6" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span *ngIf="isGenerating" class="spinner"></span>
    </button>
  </div>
</div>
